/* istanbul ignore file */
/**
 * Enumeration of Market country codes
 */
export const Market = Object.freeze({
    CA: 'CA',
    US: 'US',
    MX: 'MX',
    AU: 'AU',
    PF: 'PF',
    NC: 'NC',
    NZ: 'NZ',
    KR: 'KR',
    JP: 'JP',
    CN: 'CN',
    HK: 'HK',
    MC: 'MC',
    TW: 'TW',
    GB: 'GB',
    AT: 'AT',
    BE: 'BE',
    CH: 'CH',
    CZ: 'CZ',
    DE: 'DE',
    DK: 'DK',
    FI: 'FI',
    ES: 'ES',
    FR: 'FR',
    HU: 'HU',
    IE: 'IE',
    IL: 'IL',
    IS: 'IS',
    IT: 'IT',
    LU: 'LU',
    NL: 'NL',
    NO: 'NO',
    PL: 'PL',
    PT: 'PT',
    RO: 'RO',
    RU: 'RU',
    SE: 'SE',
    SK: 'SK',
    UA: 'UA',
    ZA: 'ZA',
    SG: 'SG',
    MY: 'MY',
    BN: 'BN',
    TH: 'TH',
    PH: 'PH'
});
